import http from "@/axios/http-common";
import ErrorAlert from "@/utility/ErrorAlert";

async function get(id) {
  return await http.getData(`/register/${id}`);
}

async function changeDokter(register, unit_id, cdoc_id, tgl) {
  const response = await http
    .putData(`/register/${register}/change-dokter`, {
      unit_id: unit_id,
      cdoc_id: cdoc_id,
      tgl: tgl
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function changeDpjp(register, cdoc_id) {
  const response = await http
    .putData(`/register/${register}/change-dpjp`, {
      doc_id: cdoc_id
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function getInfoBpjs(regId) {
  const resp = await http.getData(`/register/${regId}/info-bpjs`).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return resp.data;
}

export default {
  get,
  changeDokter,
  changeDpjp,
  getInfoBpjs
};
